import { Component, ChangeDetectionStrategy, Input } from '@angular/core'

import { Store, select } from '@ngrx/store'

import { Observable } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

import { ContainerBase } from '../../../core/base/container-base'
import { DetailsContainer } from '../../../catalog/containers/details-container/details-container'

import { OrderHistory } from '../../models/orderhistory'
import { OrderHistoryLine } from '../../models/orderhistoryline'
import { CartProduct } from '../../../cart/models/cart-models';

import * as fromOrderHistory from '../../reducers'
import * as fromAuth from '../../../auth/reducers'

import * as orderhistory from '../../actions/order-history.actions'
import * as product from '../../../catalog/actions/product'
import * as catalog from '../../../catalog/actions/catalog'
import * as fromCart from '../../../cart/reducers'


@Component({
  selector: 'orderhistorylines-page-container',
  templateUrl: './orderhistorylines-page-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderhistorylinesPageContainerComponent extends ContainerBase  {

  orderHistoryItem$: Observable<OrderHistory>
  orderHistoryLines$: Observable<OrderHistoryLine[]>
  reOrderableProductCodes$: Observable<string[]>
  loading$: Observable<boolean>
  expanding$: Observable<boolean>
  currency$: Observable<string>

  cartProducts$: Observable<{[product: string]: CartProduct}>

  constructor(
    private store: Store<fromOrderHistory.State>,
    private modalSvc: NgbModal
  ) {
    super()

    this.orderHistoryItem$ = store.pipe(
      select(fromOrderHistory.getOrderHistoryItem),
      takeUntil(this.destroyed$)
    )

    this.orderHistoryLines$ = store.pipe(
      select(fromOrderHistory.getOrderHistoryLines),
      takeUntil(this.destroyed$)
    )

    this.loading$ = store.pipe(
      select(fromOrderHistory.getOrderHistoryLinesLoading),
      takeUntil(this.destroyed$)
    )

    this.expanding$ = store.pipe(
      select(fromOrderHistory.getOrderHistoryLinesExpanding),
      takeUntil(this.destroyed$)
    )

    this.cartProducts$ = store
    .pipe(
      select(fromCart.getCartProducts),
      takeUntil(this.destroyed$)
    )

    this.reOrderableProductCodes$ = store.pipe(
      select(fromOrderHistory.getReOrderableItemCodes),
      takeUntil(this.destroyed$)
    )

    this.currency$ = store.pipe(
      select(fromAuth.getCurrency),
      takeUntil(this.destroyed$)
    )

    this.store.dispatch(new orderhistory.LoadOrderHistoryItem())
    this.store.dispatch(new orderhistory.LoadOrderHistoryLines())
    this.store.dispatch(new orderhistory.LoadReOrderableItems())
   }

   expand() {
     this.store.dispatch(new orderhistory.LoadOrderHistoryLinesExpand())
   }

   reOrder(productId: string) {
    this.store.dispatch(new catalog.Init())
    this.store.dispatch(new product.Select(productId))
    this.modalSvc.open(DetailsContainer, {centered: true, size: 'lg'})
   }
}
